import { FormWarning } from "@shltelemedicine/shl-ui-lib";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { openFile } from "../../../utils/fileUtil";

type OpenReportProps = {
  file?: Blob;
  titleStringId?: string;
  linkStringId?: string;
};

const OpenReport = ({ file, titleStringId, linkStringId }: OpenReportProps) => {
  const [fileUrl, setFileUrl] = useState<string>();

  useEffect(() => {
    if (!file) {
      return;
    }

    const fileUrl = openFile(file);
    if (fileUrl) {
      setFileUrl(fileUrl);
    }
  }, [file]);

  return (
    <div className="d-flex flex-column">
      <FormWarning
        message={<FormattedMessage id={titleStringId} />}
        className="app-hint mb-2 px-3"
      />
      {fileUrl && (
        <a
          className="app-link align-self-center"
          href={fileUrl}
          target="_blank"
          rel="noreferrer"
        >
          <FormattedMessage id={linkStringId} />
        </a>
      )}
    </div>
  );
};

export default OpenReport;
